import { Button, Col, Input, Row, Select, Table, Tooltip } from "antd";
import { EyeFilled } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import { ESTATUS_CON_OBSERVACIONES, ESTATUS_OBSERVACIONES_ATENDIDAS, ESTATUS_SIN_REVISION, ESTATUS_VALIDADO } from "../../../utils/constanst";

function TableValOrg(props) {
    const { data, loading, rolModulo, moduloAbierto } = props;
    const [dataSource, setDataSource] = useState([]); //hook para almacenar el arrar para la tabla 
    const [dataSourceCopy, setDataSourceCopy] = useState([]); //hook copia para almacenar el array (filtros tabla)
    const [filtroEstadoRev, setFiltroEstadoRev] = useState(0);
    const [filtroNombreOrg, setfiltroNombreOrg] = useState("");
    const [filtroCodigoOrg, setfiltroCodigoOrg] = useState("");

    useEffect(() => {
        setDataSource(data);
        setDataSourceCopy(data);
    }, [data]);

    const FilterByNombreOrg = (
        <>
            Nombre de la organización
            <Input placeholder="Nombre de la organización"
                value={filtroNombreOrg}
                onChange={(e) => {
                    const currValue = e.target.value;
                    setfiltroNombreOrg(currValue);
                    const filteredData = dataSourceCopy.filter((entry) =>
                        entry.organizacion.toLowerCase().includes(currValue.toLowerCase())
                        && entry.codigo.toLowerCase().includes(filtroCodigoOrg.toLowerCase())
                    );
                    setDataSource(filteredData);
                }}
            />
        </>
    );

    const FilterByCodigoOrg = (
        <>
            Código
            <Input placeholder="Código"
                value={filtroCodigoOrg}
                onChange={(e) => {
                    const currValue = e.target.value;
                    setfiltroCodigoOrg(currValue);
                    const filteredData = dataSourceCopy.filter((entry) =>
                        entry.codigo.toLowerCase().includes(currValue.toLowerCase())
                        && entry.organizacion.toLowerCase().includes(filtroNombreOrg.toLowerCase())
                    );
                    setDataSource(filteredData);
                }}
            />
        </>
    );

    const columnas = [
        {
            title: "#",
            dataIndex: "indice",
        },
        {
            title: FilterByNombreOrg,
            dataIndex: "organizacion",
            width: 300
        },
        {
            title: FilterByCodigoOrg,
            dataIndex: "codigo",
            width: 160
        },
        {
            title: "Fecha de alta",
            dataIndex: "fechaAlta",
            render: (record) => moment(record).format("DD/MM/YYYY"), //Formato a la fecha
        },
        {
            title: "Nombre del representante",
            dataIndex: "nombreCompletoRepre",
        },
        {
            title: "Estado de la revisión",
            dataIndex: "estadoRev",
            width: 140
        },
        {
            title: "Validada por",
            dataIndex: "validadoPor",
        },
        {
            title: "Tipo de organización",
            dataIndex: "tipoOrganizacion",
            width: 175
        },
        {
            title: "Acciones",
            fixed: "right",
            align: "center",
            render: (record) => (
                <>
                    {(record.idEstatus === ESTATUS_CON_OBSERVACIONES || record.idEstatus === ESTATUS_VALIDADO) && (
                        <Tooltip title="Visualizar">
                            <Link to={{ pathname:"/admin/validacionOrg/consultar",
                                idOrg:record.idOrganizacion}}>
                                <Button className="btn-circle btn_secundario">
                                    <EyeFilled />
                                </Button>
                            </Link>
                        </Tooltip>
                    )}
                    {(record.idEstatus === ESTATUS_SIN_REVISION || record.idEstatus === ESTATUS_OBSERVACIONES_ATENDIDAS) && (
                        <Tooltip title="Revisar">

                            <Link   to={{ pathname:"/admin/validacionOrg/validar", idOrg:record.idOrganizacion}} 
                                    disabled={!rolModulo.captura || !moduloAbierto} >

                                <Button type="default" 
                                        style={{ width: 90 }} 
                                        disabled={!rolModulo.captura || !moduloAbierto}>
                                    Revisar
                                </Button>
                            </Link>

                        </Tooltip>
                    )}
                </>
            )
        }
    ];

    function onChangeEstadoRev(value) {
        setFiltroEstadoRev(value);
        setfiltroNombreOrg("");
        if(value === 0) { //Todos
            setDataSource(data);
            setDataSourceCopy(data);
        } else {
            const filteredData = data.filter((entry) =>
                entry.idEstatus
                    .toString()
                    .includes(value.toString())
            );
            setDataSource(filteredData);
            setDataSourceCopy(filteredData);
        }
    }

    return (
        <>
            <Row style={{ marginTop:"20px"}}>
                <Col span={24}>
                    <h5>Estado de la revisión</h5>
                    <Select value={filtroEstadoRev} style={{ width: 210 }} onChange={onChangeEstadoRev}>
                        <Select.Option value={0}>Todos</Select.Option>
                        <Select.Option value={1}>Sin revisión</Select.Option>
                        <Select.Option value={2}>Observaciones atendidas</Select.Option>
                        <Select.Option value={3}>Con observaciones</Select.Option>
                        <Select.Option value={4}>Validada</Select.Option>
                    </Select>
                </Col>
            </Row>
            <Row style={{ marginTop:"20px"}}>
                <Col span={24}>
                    <Table dataSource={dataSource} columns={columnas}
                        loading={loading} locale={{ emptyText: "Sin registros" }}
                        scroll={{ x:true }}
                    />
                </Col>
            </Row>
        </>
    );
}

export default withRouter(TableValOrg);